import { BankTransactionKind, TransactionType } from './banking.types';
export var FinAPIWebFormVisibility;
(function (FinAPIWebFormVisibility) {
    FinAPIWebFormVisibility["RENDER"] = "RENDER";
    FinAPIWebFormVisibility["HIDDEN"] = "HIDDEN";
})(FinAPIWebFormVisibility || (FinAPIWebFormVisibility = {}));
export var FinAPIWebFormBankLoginHint;
(function (FinAPIWebFormBankLoginHint) {
    FinAPIWebFormBankLoginHint["EXPANDED"] = "EXPANDED";
    FinAPIWebFormBankLoginHint["COLLAPSED"] = "COLLAPSED";
    FinAPIWebFormBankLoginHint["HIDDEN"] = "HIDDEN";
})(FinAPIWebFormBankLoginHint || (FinAPIWebFormBankLoginHint = {}));
export var FinAPIWebFormMessageForm;
(function (FinAPIWebFormMessageForm) {
    FinAPIWebFormMessageForm["FORMAL"] = "FORMAL";
    FinAPIWebFormMessageForm["INFORMAL"] = "INFORMAL";
})(FinAPIWebFormMessageForm || (FinAPIWebFormMessageForm = {}));
export var FinAPIWebFormTheme;
(function (FinAPIWebFormTheme) {
    FinAPIWebFormTheme["DEFAULT"] = "DEFAULT";
    FinAPIWebFormTheme["MOBILE_MINIMALISTIC"] = "MOBILE_MINIMALISTIC";
    FinAPIWebFormTheme["DEFAULT_V2_1"] = "DEFAULT_V2_1";
})(FinAPIWebFormTheme || (FinAPIWebFormTheme = {}));
export var FinAPIConnectionStatus;
(function (FinAPIConnectionStatus) {
    FinAPIConnectionStatus["PENDING"] = "PENDING";
    FinAPIConnectionStatus["ACTIVE"] = "ACTIVE";
    FinAPIConnectionStatus["UPDATE_REQUIRED"] = "UPDATE_REQUIRED";
    FinAPIConnectionStatus["EXPIRED"] = "EXPIRED";
    FinAPIConnectionStatus["FAILED"] = "FAILED";
    FinAPIConnectionStatus["REVOKED"] = "REVOKED";
})(FinAPIConnectionStatus || (FinAPIConnectionStatus = {}));
export var FinAPIConsentStatus;
(function (FinAPIConsentStatus) {
    FinAPIConsentStatus["ACTIVE"] = "ACTIVE";
    FinAPIConsentStatus["EXPIRED"] = "EXPIRED";
    FinAPIConsentStatus["REVOKED"] = "REVOKED";
})(FinAPIConsentStatus || (FinAPIConsentStatus = {}));
export var FinAPIConsentExpirySource;
(function (FinAPIConsentExpirySource) {
    FinAPIConsentExpirySource["BANK"] = "BANK";
    FinAPIConsentExpirySource["DEFAULT"] = "DEFAULT";
})(FinAPIConsentExpirySource || (FinAPIConsentExpirySource = {}));
export const FINAPI_CONSENT_NOTICE_MS = 7 * 24 * 60 * 60 * 1000;
export var FinAPIConsentScope;
(function (FinAPIConsentScope) {
    FinAPIConsentScope["AIS"] = "AIS";
    FinAPIConsentScope["PIS"] = "PIS";
})(FinAPIConsentScope || (FinAPIConsentScope = {}));
export var FinAPIPaymentStatus;
(function (FinAPIPaymentStatus) {
    FinAPIPaymentStatus["CREATED"] = "CREATED";
    FinAPIPaymentStatus["SCA_PENDING"] = "SCA_PENDING";
    FinAPIPaymentStatus["EXECUTING"] = "EXECUTING";
    FinAPIPaymentStatus["EXECUTED"] = "EXECUTED";
    FinAPIPaymentStatus["FAILED"] = "FAILED";
    FinAPIPaymentStatus["CANCELLED"] = "CANCELLED";
})(FinAPIPaymentStatus || (FinAPIPaymentStatus = {}));
export var FinAPIWebFormStatus;
(function (FinAPIWebFormStatus) {
    FinAPIWebFormStatus["NOT_YET_OPENED"] = "NOT_YET_OPENED";
    FinAPIWebFormStatus["IN_PROGRESS"] = "IN_PROGRESS";
    FinAPIWebFormStatus["COMPLETED"] = "COMPLETED";
    FinAPIWebFormStatus["COMPLETED_WITH_ERROR"] = "COMPLETED_WITH_ERROR";
    FinAPIWebFormStatus["ABORTED"] = "ABORTED";
    FinAPIWebFormStatus["EXPIRED"] = "EXPIRED";
})(FinAPIWebFormStatus || (FinAPIWebFormStatus = {}));
export var FinAPIWebFormType;
(function (FinAPIWebFormType) {
    FinAPIWebFormType["CONNECT_BANK"] = "CONNECT_BANK";
    FinAPIWebFormType["CONSENT_RENEWAL"] = "CONSENT_RENEWAL";
    FinAPIWebFormType["PAYMENT"] = "PAYMENT";
    FinAPIWebFormType["STANDING_ORDER"] = "STANDING_ORDER";
})(FinAPIWebFormType || (FinAPIWebFormType = {}));
export var SavingsPlanStatus;
(function (SavingsPlanStatus) {
    SavingsPlanStatus["DRAFT"] = "DRAFT";
    SavingsPlanStatus["AWAITING_SETUP"] = "AWAITING_SETUP";
    SavingsPlanStatus["ACTIVE"] = "ACTIVE";
    SavingsPlanStatus["FAILED"] = "FAILED";
    SavingsPlanStatus["CANCELLED"] = "CANCELLED";
})(SavingsPlanStatus || (SavingsPlanStatus = {}));
export var SavingsPlanExecutionStatus;
(function (SavingsPlanExecutionStatus) {
    SavingsPlanExecutionStatus["BUY_QUEUED"] = "BUY_QUEUED";
    SavingsPlanExecutionStatus["BUY_EXECUTING"] = "BUY_EXECUTING";
    SavingsPlanExecutionStatus["BUY_COMPLETED"] = "BUY_COMPLETED";
    SavingsPlanExecutionStatus["BUY_FAILED_RETRY"] = "BUY_FAILED_RETRY";
    SavingsPlanExecutionStatus["BUY_FAILED_MANUAL"] = "BUY_FAILED_MANUAL";
})(SavingsPlanExecutionStatus || (SavingsPlanExecutionStatus = {}));
export var SavingsPlanFrequency;
(function (SavingsPlanFrequency) {
    SavingsPlanFrequency["MONTHLY"] = "MONTHLY";
})(SavingsPlanFrequency || (SavingsPlanFrequency = {}));
export const FINAPI_CONNECTION_VALID_TRANSITIONS = {
    [FinAPIConnectionStatus.PENDING]: [
        FinAPIConnectionStatus.ACTIVE,
        FinAPIConnectionStatus.UPDATE_REQUIRED,
        FinAPIConnectionStatus.FAILED,
        FinAPIConnectionStatus.EXPIRED,
        FinAPIConnectionStatus.REVOKED,
    ],
    [FinAPIConnectionStatus.ACTIVE]: [
        FinAPIConnectionStatus.UPDATE_REQUIRED,
        FinAPIConnectionStatus.EXPIRED,
        FinAPIConnectionStatus.REVOKED,
    ],
    [FinAPIConnectionStatus.UPDATE_REQUIRED]: [
        FinAPIConnectionStatus.ACTIVE,
        FinAPIConnectionStatus.EXPIRED,
        FinAPIConnectionStatus.REVOKED,
    ],
    [FinAPIConnectionStatus.EXPIRED]: [
        FinAPIConnectionStatus.ACTIVE,
        FinAPIConnectionStatus.UPDATE_REQUIRED,
        FinAPIConnectionStatus.REVOKED,
    ],
    [FinAPIConnectionStatus.FAILED]: [FinAPIConnectionStatus.PENDING, FinAPIConnectionStatus.REVOKED],
    [FinAPIConnectionStatus.REVOKED]: [],
};
export const FINAPI_CONSENT_VALID_TRANSITIONS = {
    [FinAPIConsentStatus.ACTIVE]: [FinAPIConsentStatus.EXPIRED, FinAPIConsentStatus.REVOKED],
    [FinAPIConsentStatus.EXPIRED]: [FinAPIConsentStatus.REVOKED],
    [FinAPIConsentStatus.REVOKED]: [],
};
export const FINAPI_PAYMENT_VALID_TRANSITIONS = {
    [FinAPIPaymentStatus.CREATED]: [
        FinAPIPaymentStatus.SCA_PENDING,
        FinAPIPaymentStatus.EXECUTING,
        FinAPIPaymentStatus.EXECUTED,
        FinAPIPaymentStatus.FAILED,
        FinAPIPaymentStatus.CANCELLED,
    ],
    [FinAPIPaymentStatus.SCA_PENDING]: [
        FinAPIPaymentStatus.EXECUTING,
        FinAPIPaymentStatus.EXECUTED,
        FinAPIPaymentStatus.FAILED,
        FinAPIPaymentStatus.CANCELLED,
    ],
    [FinAPIPaymentStatus.EXECUTING]: [FinAPIPaymentStatus.EXECUTED, FinAPIPaymentStatus.FAILED],
    [FinAPIPaymentStatus.EXECUTED]: [],
    [FinAPIPaymentStatus.FAILED]: [],
    [FinAPIPaymentStatus.CANCELLED]: [],
};
export const isValidFinAPIConnectionTransition = (from, to) => FINAPI_CONNECTION_VALID_TRANSITIONS[from].includes(to);
export const isValidFinAPIConsentTransition = (from, to) => FINAPI_CONSENT_VALID_TRANSITIONS[from].includes(to);
export const isValidFinAPIPaymentTransition = (from, to) => FINAPI_PAYMENT_VALID_TRANSITIONS[from].includes(to);
export const FINAPI_WEB_FORM_TERMINAL_STATUSES = [
    FinAPIWebFormStatus.COMPLETED,
    FinAPIWebFormStatus.COMPLETED_WITH_ERROR,
    FinAPIWebFormStatus.ABORTED,
    FinAPIWebFormStatus.EXPIRED,
];
export const isTerminalFinAPIWebFormStatus = (status) => FINAPI_WEB_FORM_TERMINAL_STATUSES.includes(status);
export const FINAPI_PAYMENT_OPEN_STATUSES = [
    FinAPIPaymentStatus.CREATED,
    FinAPIPaymentStatus.SCA_PENDING,
    FinAPIPaymentStatus.EXECUTING,
];
export const isOpenFinAPIPaymentStatus = (status) => FINAPI_PAYMENT_OPEN_STATUSES.includes(status);
export const FINAPI_CONNECT_STALE_AFTER_MS = 30 * 60 * 1000;
export const FINAPI_CONNECT_SWEEP_AFTER_MS = 2 * 60 * 1000;
export const finapiRawConnectionBankId = (raw) => raw.bank?.id ?? raw.bankId;
export const finapiRawConnectionConsentExpiry = (raw) => (raw.interfaces ?? [])
    .map(i => i.aisConsent?.expiresAt)
    .filter((value) => typeof value === 'string' && !Number.isNaN(Date.parse(value)))
    .map(value => new Date(value))
    .sort((a, b) => a.getTime() - b.getTime())[0];
export const finapiBankConsentLapsed = (raw, now = Date.now()) => {
    const expiry = finapiRawConnectionConsentExpiry(raw);
    return expiry !== undefined && expiry.getTime() <= now;
};
export const SAVINGS_PLAN_VALID_TRANSITIONS = {
    [SavingsPlanStatus.DRAFT]: [SavingsPlanStatus.AWAITING_SETUP, SavingsPlanStatus.FAILED],
    [SavingsPlanStatus.AWAITING_SETUP]: [SavingsPlanStatus.ACTIVE, SavingsPlanStatus.FAILED, SavingsPlanStatus.CANCELLED],
    [SavingsPlanStatus.ACTIVE]: [SavingsPlanStatus.CANCELLED, SavingsPlanStatus.FAILED],
    [SavingsPlanStatus.FAILED]: [SavingsPlanStatus.CANCELLED],
    [SavingsPlanStatus.CANCELLED]: [],
};
export const SAVINGS_PLAN_EXECUTION_VALID_TRANSITIONS = {
    [SavingsPlanExecutionStatus.BUY_QUEUED]: [
        SavingsPlanExecutionStatus.BUY_EXECUTING,
        SavingsPlanExecutionStatus.BUY_FAILED_RETRY,
        SavingsPlanExecutionStatus.BUY_FAILED_MANUAL,
    ],
    [SavingsPlanExecutionStatus.BUY_EXECUTING]: [
        SavingsPlanExecutionStatus.BUY_COMPLETED,
        SavingsPlanExecutionStatus.BUY_FAILED_RETRY,
        SavingsPlanExecutionStatus.BUY_FAILED_MANUAL,
    ],
    [SavingsPlanExecutionStatus.BUY_FAILED_RETRY]: [
        SavingsPlanExecutionStatus.BUY_EXECUTING,
        SavingsPlanExecutionStatus.BUY_FAILED_MANUAL,
    ],
    [SavingsPlanExecutionStatus.BUY_COMPLETED]: [],
    [SavingsPlanExecutionStatus.BUY_FAILED_MANUAL]: [],
};
export const isValidSavingsPlanTransition = (from, to) => SAVINGS_PLAN_VALID_TRANSITIONS[from].includes(to);
export const isValidSavingsPlanExecutionTransition = (from, to) => SAVINGS_PLAN_EXECUTION_VALID_TRANSITIONS[from].includes(to);
export const SAVINGS_PLAN_END_TO_END_PREFIX = 'MG-SP-';
export const buildSavingsPlanEndToEndId = (planId) => {
    return `${SAVINGS_PLAN_END_TO_END_PREFIX}${planId}`.slice(0, 35);
};
export const isSavingsPlanEndToEndId = (endToEndId) => !!endToEndId && endToEndId.startsWith(SAVINGS_PLAN_END_TO_END_PREFIX);
const finapiAccountTypeNameToDomain = (raw) => {
    if (!raw)
        return 'OTHER';
    const upper = raw.toUpperCase();
    if (upper.includes('CHECK') || upper.includes('GIRO') || upper.includes('CURRENT'))
        return 'CHECKING';
    if (upper.includes('SAV') || upper.includes('SPAR') || upper.includes('TAGESGELD'))
        return 'SAVINGS';
    if (upper.includes('CREDIT') || upper.includes('CARD') || upper.includes('KREDIT'))
        return 'CREDIT_CARD';
    if (upper.includes('SECURIT') || upper.includes('DEPOT') || upper.includes('BROKER') || upper.includes('WERTPAPIER'))
        return 'SECURITIES';
    return 'OTHER';
};
const toCents = (decimal) => {
    if (decimal === undefined || decimal === null || Number.isNaN(decimal))
        return 0;
    return Math.round(decimal * 100);
};
const finapiAccountLastUpdated = (raw) => {
    const interfaceDates = (raw.interfaces ?? [])
        .map(i => (i.lastSuccessfulUpdate ? new Date(i.lastSuccessfulUpdate).getTime() : NaN))
        .filter(t => !Number.isNaN(t));
    if (interfaceDates.length > 0)
        return new Date(Math.max(...interfaceDates));
    if (raw.importDate)
        return new Date(raw.importDate);
    if (raw.lastUpdate)
        return new Date(raw.lastUpdate);
    return new Date(0);
};
export const mapFinAPIAccount = (raw, bankName) => ({
    provider: 'finapi',
    id: `finapi:${raw.id}`,
    finapiAccountId: raw.id,
    finapiConnectionId: raw.bankConnectionId,
    iban: raw.iban ?? '',
    bic: raw.bic,
    bankName,
    accountHolderName: raw.accountHolderName ?? '',
    accountType: finapiAccountTypeNameToDomain(raw.accountType ?? raw.accountTypeName),
    balanceCents: toCents(raw.balance),
    availableBalanceCents: raw.availableBalance === undefined ? undefined : toCents(raw.availableBalance),
    currency: 'EUR',
    lastUpdatedAt: finapiAccountLastUpdated(raw),
    supportsPayments: finapiAccountSupportsPayments(raw),
    supportsStandingOrders: finapiAccountSupportsStandingOrders(raw),
});
const finapiAccountSupportsPayments = (raw) => {
    const interfaces = raw.interfaces ?? [];
    if (interfaces.length === 0)
        return true;
    return interfaces.some(i => (i.capabilities ?? []).includes('SEPA_MONEY_TRANSFER'));
};
const finapiAccountSupportsStandingOrders = (raw) => {
    const interfaces = raw.interfaces ?? [];
    if (interfaces.length === 0)
        return true;
    return interfaces.some(i => (i.capabilities ?? []).includes('STANDING_ORDER'));
};
const GVC_KIND_MAP = {
    4: BankTransactionKind.DIRECT_DEBIT,
    5: BankTransactionKind.DIRECT_DEBIT,
    20: BankTransactionKind.TRANSFER,
    51: BankTransactionKind.TRANSFER,
    52: BankTransactionKind.STANDING_ORDER,
    53: BankTransactionKind.SALARY,
    104: BankTransactionKind.DIRECT_DEBIT,
    105: BankTransactionKind.DIRECT_DEBIT,
    106: BankTransactionKind.CARD_PAYMENT,
    109: BankTransactionKind.DIRECT_DEBIT,
    116: BankTransactionKind.TRANSFER,
    117: BankTransactionKind.STANDING_ORDER,
    118: BankTransactionKind.TRANSFER,
    119: BankTransactionKind.SALARY,
    152: BankTransactionKind.STANDING_ORDER,
    153: BankTransactionKind.SALARY,
    166: BankTransactionKind.TRANSFER,
    177: BankTransactionKind.TRANSFER,
    808: BankTransactionKind.FEE,
};
const ISO_BTC_KIND_RULES = [
    [/CWDL/, BankTransactionKind.CASH_WITHDRAWAL],
    [/CDPT/, BankTransactionKind.CASH_DEPOSIT],
    [/SALA|PENS/, BankTransactionKind.SALARY],
    [/STDO/, BankTransactionKind.STANDING_ORDER],
    [/INTR/, BankTransactionKind.INTEREST],
    [/CHRG|FEES/, BankTransactionKind.FEE],
    [/POSD|POSP|CCRD|MCRD/, BankTransactionKind.CARD_PAYMENT],
    [/ICDT|RCDT|ESCT/, BankTransactionKind.TRANSFER],
    [/IDDT|RDDT|ESDD|BBDD|PADD/, BankTransactionKind.DIRECT_DEBIT],
];
const TYPE_TEXT_KIND_RULES = [
    [/lastschrift/, BankTransactionKind.DIRECT_DEBIT],
    [/dauerauftrag/, BankTransactionKind.STANDING_ORDER],
    [/gehalt|lohn|rente|pension|bez(ü|ue)ge/, BankTransactionKind.SALARY],
    [/(ü|ue?)berweisung/, BankTransactionKind.TRANSFER],
    [/kartenzahlung|girocard|kartenverf(ü|ue)gung/, BankTransactionKind.CARD_PAYMENT],
    [/geldautomat|bargeldaus|bargeldabheb|abhebung|auszahlung|\batm\b/, BankTransactionKind.CASH_WITHDRAWAL],
    [/bareinzahlung|bargeldein/, BankTransactionKind.CASH_DEPOSIT],
    [/zins/, BankTransactionKind.INTEREST],
    [/geb(ü|ue)hr|entgelt|kontof(ü|ue)hrung/, BankTransactionKind.FEE],
    [/gutschrift/, BankTransactionKind.CREDIT],
];
export const deriveBankTransactionKind = (raw) => {
    const purposeCode = raw.sepaPurposeCode?.toUpperCase() ?? '';
    if (purposeCode === 'SALA' || purposeCode === 'PENS')
        return BankTransactionKind.SALARY;
    const gvc = Number.parseInt(raw.typeCodeZka ?? '', 10);
    const fromGvc = Number.isNaN(gvc) ? undefined : GVC_KIND_MAP[gvc];
    if (fromGvc)
        return fromGvc;
    const btc = raw.bankTransactionCode?.toUpperCase();
    if (btc) {
        const rule = ISO_BTC_KIND_RULES.find(([re]) => re.test(btc));
        if (rule)
            return rule[1];
    }
    if (raw.counterpartCreditorId)
        return BankTransactionKind.DIRECT_DEBIT;
    if (raw.counterpartDebitorId)
        return BankTransactionKind.TRANSFER;
    const typeText = raw.type?.toLowerCase();
    if (typeText) {
        const rule = TYPE_TEXT_KIND_RULES.find(([re]) => re.test(typeText));
        if (rule)
            return rule[1];
    }
    return raw.amount > 0 ? BankTransactionKind.CREDIT : BankTransactionKind.PAYMENT;
};
export const mapFinAPITransaction = (raw) => {
    const isIncoming = raw.amount > 0;
    const bookingDate = raw.bankBookingDate ?? raw.bookingDate;
    return {
        id: `finapi:${raw.id}`,
        providerAccountId: `finapi:${raw.accountId}`,
        type: isIncoming ? TransactionType.DEPOSIT : TransactionType.WITHDRAWAL,
        kind: deriveBankTransactionKind(raw),
        amount: raw.amount,
        currency: raw.currency ?? 'EUR',
        description: raw.purpose,
        senderName: isIncoming ? raw.counterpartName : undefined,
        senderIban: isIncoming ? raw.counterpartIban : undefined,
        senderBic: isIncoming ? raw.counterpartBic : undefined,
        recipientName: isIncoming ? undefined : raw.counterpartName,
        recipientIban: isIncoming ? undefined : raw.counterpartIban,
        recipientBic: isIncoming ? undefined : raw.counterpartBic,
        receiptDate: raw.valueDate ? new Date(raw.valueDate) : undefined,
        confirmDate: bookingDate ? new Date(bookingDate) : undefined,
        userReference: raw.endToEndReference,
    };
};
export const mapFinAPIConnectionStatus = (raw) => {
    const upper = raw?.toUpperCase() ?? '';
    if (upper === 'OK' || upper === 'ACTIVE' || upper === 'SUCCESS')
        return FinAPIConnectionStatus.ACTIVE;
    if (upper.includes('UPDATE') || upper.includes('REAUTH') || upper.includes('LOGIN')) {
        return FinAPIConnectionStatus.UPDATE_REQUIRED;
    }
    if (upper.includes('EXPIR'))
        return FinAPIConnectionStatus.EXPIRED;
    if (upper.includes('REVOK') || upper.includes('DELET'))
        return FinAPIConnectionStatus.REVOKED;
    if (upper.includes('FAIL') || upper.includes('ERROR'))
        return FinAPIConnectionStatus.FAILED;
    return FinAPIConnectionStatus.PENDING;
};
export const deriveFinAPIConnectionStatus = (raw) => {
    const interfaces = raw.interfaces ?? [];
    if (interfaces.some(i => i.userActionRequired === true)) {
        return FinAPIConnectionStatus.UPDATE_REQUIRED;
    }
    if (interfaces.some(i => (i.aisConsent?.status ?? '').toUpperCase().includes('EXPIR'))) {
        return FinAPIConnectionStatus.EXPIRED;
    }
    const isHealthy = (i) => (i.lastManualUpdate?.result ?? '').toUpperCase() === 'OK' ||
        (i.lastAutoUpdate?.result ?? '').toUpperCase() === 'OK' ||
        (i.aisConsent?.status ?? '').toUpperCase() === 'PRESENT';
    if (interfaces.some(isHealthy)) {
        return FinAPIConnectionStatus.ACTIVE;
    }
    return mapFinAPIConnectionStatus(raw.status);
};
export const mapFinAPIPaymentStatus = (raw) => {
    const upper = raw.toUpperCase();
    if (upper === 'SUCCESSFUL' || upper === 'EXECUTED' || upper === 'COMPLETED' || upper === 'SUCCESS') {
        return FinAPIPaymentStatus.EXECUTED;
    }
    if (upper === 'NOT_SUCCESSFUL' || upper === 'FAILED' || upper === 'REJECTED' || upper === 'ERROR') {
        return FinAPIPaymentStatus.FAILED;
    }
    if (upper === 'DISCARDED' || upper === 'CANCELLED' || upper === 'CANCELED' || upper === 'ABORTED') {
        return FinAPIPaymentStatus.CANCELLED;
    }
    if (upper === 'PENDING' ||
        upper === 'UNKNOWN' ||
        upper === 'EXECUTING' ||
        upper === 'PROCESSING' ||
        upper === 'PENDING_SETTLEMENT') {
        return FinAPIPaymentStatus.EXECUTING;
    }
    if (upper === 'OPEN' ||
        upper === 'SCA_PENDING' ||
        upper === 'PENDING_AUTHORIZATION' ||
        upper === 'AUTHORIZATION_PENDING') {
        return FinAPIPaymentStatus.SCA_PENDING;
    }
    return FinAPIPaymentStatus.CREATED;
};
export const FINAPI_PAYMENT_LIMITS = {
    PER_TRANSACTION_CENTS: 500000,
    DAILY_AGGREGATE_CENTS: 1000000,
    MONTHLY_AGGREGATE_CENTS: 2500000,
    PURPOSE_MAX_LENGTH: 140,
    PURPOSE_ALLOWED_PATTERN: /^[A-Za-z0-9 ,'.+\-/()?:!"#%&*<>;{@_=À-ſ]*$/,
};
export const isValidFinAPIPurpose = (purpose) => purpose.length > 0 &&
    purpose.length <= FINAPI_PAYMENT_LIMITS.PURPOSE_MAX_LENGTH &&
    FINAPI_PAYMENT_LIMITS.PURPOSE_ALLOWED_PATTERN.test(purpose);
//# sourceMappingURL=finapi.types.js.map